document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".color-swatch").forEach(function(swatch) {
        swatch.addEventListener("click", function() {
            if (swatch.classList.contains("is-disabled")) {
                document.getElementById("notify-message").style.display = "block";
            } else {
                document.getElementById("notify-message").style.display = "none";
            }
        });
    });
});
